import * as API from '@/services/API'

export default {
    getPays() {
        // const session_id = store.getters['auth/user_session_id']
        return API.apiClient.get('/pays')
    }
}
